export default __webpack_public_path__ + "static/media/pdf.e190186c.svg";